<div class="content-container">
  <div class="checkmark-container">
    <span class="check-emoji">✅</span>
  </div>
  <div class="title-container">
    <p class="title">
      {{
        isDirectOrder
          ? 'Bedankt voor uw bestelling'
          : 'Bedankt voor uw aanvraag'
      }}
    </p>
  </div>
  <p class="subtitle">
    {{
      isDirectOrder
        ? 'U zal weldra een bevestigingsmail ontvangen, we gaan spoedig aan de slag met de productie van uw nieuwe borden'
        : 'Onze offertedienst zal u spoedig een voorstel aanbieden'
    }}
  </p>
  <div class="button-container">
    <button
      mat-raised-button
      color="primary"
      class="red-primary"
      (click)="closeDialog()"
    >
      Sluit dit venster
    </button>
  </div>
</div>
